@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../settings-page.module.less';

.table-container {
  display: flex;
  flex-direction: column;
  border: @settings-page--table--border;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
  background-color: @settings-page--table--body--cell--background-color;
  overflow-x: auto;
  width: 100%;
  color: @settings-page--table--body--cell--text-color;
}

.table-header {
  display: grid;
  grid-template-columns: minmax(200px, 6fr) 120px 160px 60px;
  grid-template-rows: auto;
  font-weight: @settings-page--table--header--cell--font-weight;
  border-bottom: @settings-page--table--border;
  min-width: 810px;
  background: @settings-page--table--header--cell--background-color;
  color: @settings-page--table--header--cell--text-color;

  @media (max-width: 1099px) {
    grid-template-columns: minmax(150px, 6fr) 100px 160px 60px;
    min-width: 660px;
  }

  .header-cell-icon,
  .header-cell-name,
  .header-cell-category,
  .header-cell-status,
  .header-cell-actions {
    padding: @settings-page--table--cell--padding;
  }

  .header-cell-icon {
    justify-content: center;
  }

  .header-cell-name {
    justify-content: flex-start;
  }

  .header-cell-category {
    justify-content: flex-start;
  }

  .header-cell-status {
    justify-content: flex-start;
  }

  .header-cell-actions {
    justify-content: center;
  }
}

.loading-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: @space-12;
  padding: @space-32;
  min-width: 750px;

  @media (max-width: 1099px) {
    min-width: 600px;
  }
}
